/*
 * @Author: wangshengqiang
 * @Date: 2021-04-22 15:42:04
 * @LastEditTime: 2021-06-10 16:01:59
 * @LastEditors: wangshengqiang
 * @Description: 手机号
 */
import { withProps } from '@/hoc';
import RowInput from '../RowInput';
export default withProps(RowInput, {
  maxLength: 11,
  inputType: 'tel',
  rules: [{
    require: true,
    message: '请输入'
  }]
});